<div class="container-fuid bg-white default-boxrounded">
    <div class="p-4">
        <div class="mb-3">
            <desktop-status-info-table [tableHeader]="document.name" [tableData]="document" [displayedColumns]="columnsToDisplay"></desktop-status-info-table>
        </div>
        <div class="mb-2 w-100">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="closeModal()" translate="Button.Back"></button>
        </div>
    </div>
</div>